export default __webpack_public_path__ + "static/media/query-message-gray.5dac2c82.svg";